export const logoClicked = page => ({
  type: 'Logo Clicked',
  data: { page },
});
